export default {"src":"/canvas/_next/static/media/icon-apple-t5.a6707d2a.svg","height":57,"width":57,"blurWidth":0,"blurHeight":0};